module.exports = __webpack_public_path__ + "img/plus.49b7fffb.svg";